import { defineAsyncComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const BackUp = () => import('@/views/BackUp.vue')
const NewHome = () => import('@/views/V2/Home/Index.vue')
const Apply = () => import('@/views/V2/ApplyChat.vue')
const Detail = () => import('@/views/Detail.vue')
const Activity = () => import('@/views/Activity.vue')
const Agreement = () => import('@/views/Agreement.vue')
const AgreementAI = () => import('@/views/Agreement_AI.vue')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy.vue')
const AgreementApp = () => import('@/views/Agreement_app.vue')
const PrivacyPolicyApp = () => import('@/views/PrivacyPolicy_app.vue')
const PrivacyPolicyAppAndroid = () => import('@/views/PrivacyPolicy_android.vue')
const InsideTestApply = () => import('@/views/InsideTestApply.vue')
const SysUpgrade = () => import('@/views/SysUpgrade.vue')
const PromptApp = () => import('@/views/App/PromptApp.vue')
const DownLoad = () => import('@/views/App/DownLoad.vue')
const Main = () => import('@/views/Main.vue')
const WeChatLoginTransit = () => import('@/views/WeChatLoginTransit.vue') // 微信登录中转。
const OnlineAlbum = () => import('@/views/OnlineAlbum.vue') // PC画册中转，用于中转以唤起app或小程序的。
const Doc = () => import('@/views/Doc.vue')
const Code = () => import('@/views/Code.vue')
const FeedBack = () => import('@/views/App/FeedBack.vue')
const Report = () => import('@/views/App/Report.vue')
const Glms = () => import('@/views/Glms.vue')
const GlmsDetail = () => import('@/views/GlmsDetail.vue')
const Collection = () => import('@/views/Collection.vue')
const ToolsCenter = () => import('@/views/ToolsCenter.vue')
const AllToolsDetail = () => import('@/views/AllToolsDetail.vue')
const GlmsAccessErrorPage = () => import('@/views/GlmsAccessErrorPage.vue')
const UsageSpecification = () => import('@/views/UsageSpecification.vue')
const MicroAppPortal = () => import('@/components/microApp/Portal.vue')

const GlmsShare = () => import('@/views/glmsShare/glmsShare.vue')
const AuthResult = () => import('@/views/AuthResult.vue')

const Pay = () => import('@/views/Pay/index.vue')
const PayGoods = () => import('@/views/Pay/goods.vue')
const PayOrder = () => import('@/views/Pay/order.vue')
const PayOrderFeedback = () => import('@/views/Pay/orderFeedback.vue')
const PayQuestion = () => import('@/views/Pay/question.vue')
const PayVipServicePolicy = () => import('@/views/Pay/vipServicePolicy.vue')
const PayContinuePolicy = () => import('@/views/Pay/continuePolicy.vue')
const PayInvoice = () => import('@/views/Pay/invoice.vue')

const CloudKnowledge = () => import('@/views/CloudKnowledge/index.vue')

const WxCodePage = () => import('@/views/WxCodePage.vue')
const VideoGenerate = () => import('@/views/video/VideoGenerate.vue')
const VideoShare = () => import('@/views/video/VideoShare.vue')

/**
 * vue-router 3.1.0+ push/replace cause NavigationDuplicated error
 * https://github.com/ElemeFE/element/issues/17044
 * 问题描述：xxx via a navigation guard
 * 问题原因：vue-router路由版本更新产生的问题,导致路由跳转失败抛出该错误，但并不影响程序功能
 * 解决方案：全局解决，替换路由的Push和replace方法
 * 处理步骤：在创建router实例对象之前，手动覆盖原型链的push来吞掉报错catch
 */

// const originalPush = VueRouter.prototype.push
// const originalReplace = VueRouter.prototype.replace

// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalPush.call(this, location, onResolve, function () {})
//   } else {
//     return originalPush.call(this, location).catch((err) => err)
//   }
// }

// VueRouter.prototype.replace = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalReplace.call(this, location, onResolve, function () {})
//   } else {
//     return originalReplace.call(this, location).catch((err) => err)
//   }
// }

/**
 * 针对用户中心 meta 选项
 * meta: {
 *  menuTitle: String, // 菜单名称，必填！！
 *  menuIcon: String, // 菜单icon，非必填
 *  activeMenuIcon: String, // 菜单激活icon，非必填
 *  key: String, // 菜单key，必填！！
 *  title: String, // 导航标题，必填 ！！
 *  icon: String, // 导航icon，非必填
 *  activeIcon: String, // 导航激活icon，非必填
 *  roles: Array, // 权限，非必填，为空表示无权限控制
 *  noShow: Boolean, // 是否在侧边栏显示，默认显示，true 为不显示
 *  minHeight: Boolean, // 标识采用最小高度，非必填，用于页面高度撑开
 * }
 * 使用elementUI图标：
 * 直接使用例如：el-icon-s-platform
 * 使用阿里图标：(el-icon- 是为了统一elementUI的图标样式，iconfont 是阿里图标样式必填，icon-xxx 使用的阿里图标)
 * el-icon- iconfont icon-xxx
 */

// 同步路由
export const constantRoutes = [
  {
    path: '/glmsShare',
    name: 'GlmsShare',
    component: GlmsShare,
    meta: {
      isGlmsShare: true
    }
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity
  },
  {
    path: '/developersPanel/:subpages*',
    name: 'DevelopersPanel',
    strict: false,
    component: MicroAppPortal
  },
  {
    path: '/',
    name: 'NewHome',
    component: NewHome
  },
  {
    path: '/UsageSpecification',
    name: 'UsageSpecification',
    component: UsageSpecification
  },
  {
    path: '/applyAndLogin',
    name: 'applyAndLogin',
    component: BackUp
  },
  {
    path: '/apply',
    name: 'Apply',
    component: Apply
  },
  {
    path: '/detail',
    redirect: '/main/detail'
  },
  {
    path: '/prompt',
    redirect: '/main/detail'
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement
  },
  {
    path: '/agreement_ai',
    name: 'AgreementAI',
    component: AgreementAI
  },
  {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/agreement-app',
    name: 'AgreementApp',
    component: AgreementApp
  },
  {
    path: '/app/agreement',
    name: 'AgreementAppNew',
    component: Agreement
  },
  {
    path: '/privacypolicy-app',
    name: 'PrivacyPolicyApp',
    component: PrivacyPolicyApp
  },
  {
    path: '/app/android/privacypolicy',
    name: 'PrivacyPolicyAppAndroid',
    component: PrivacyPolicyAppAndroid
  },
  {
    path: '/app/ios/privacypolicy',
    name: 'PrivacyPolicyAppIos',
    component: PrivacyPolicyAppAndroid
  },
  {
    path: '/test',
    name: 'InsideTestApply',
    component: InsideTestApply
  },
  {
    path: '/authresult',
    name: 'AuthResult',
    component: AuthResult
  },
  {
    path: '/sysupgrade',
    name: 'SysUpgrade',
    component: SysUpgrade
  },
  {
    path: '/404',
    name: 'NotFound',
    component: defineAsyncComponent(() => import('@/views/404.vue')),
    hidden: true
  },
  {
    path: '/prompt-app',
    name: 'PromptApp',
    component: PromptApp
  },
  {
    path: '/download',
    name: 'DownLoad',
    component: DownLoad
  },
  {
    path: '/glms',
    name: 'Glms',
    component: Glms
  },
  {
    path: '/WeChatLoginTransit',
    name: 'WeChatLoginTransit',
    component: WeChatLoginTransit
  },
  {
    path: '/OnlineAlbum',
    name: 'OnlineAlbum',
    component: OnlineAlbum
  },

  {
    path: '/video/share',
    name: 'VideoShare',
    component: VideoShare,
    meta: {
      isGlmsShare: true
    }
  },
  {
    path: '/main',
    component: Main,
    children: [
      {
        path: '/',
        redirect: '/main/alltoolsdetail'
      },
      {
        path: 'glmsAccessErrorPage',
        name: 'GlmsAccessErrorPage',
        component: GlmsAccessErrorPage
      },
      {
        path: 'detail',
        name: 'Detail',
        component: Detail,
        meta: {
          pageTypeName: 'glm3'
        }
      },
      {
        path: 'gdetail/:id',
        name: 'gdetail',
        component: GlmsDetail,
        meta: {
          isGlmsShare: true
        }
      },
      {
        path: '/video',
        name: 'Video',
        component: VideoGenerate,
        meta: {
          isGlmsShare: true
        }
      },
      {
        path: 'alltoolsdetail',
        name: 'alltoolsdetail',
        component: AllToolsDetail,
        meta: {
          pageType: 'alltoolsdetail',
          pageTypeName: 'glm4',
          isGlmsShare: true
        }
      },
      {
        path: 'doc',
        name: 'Doc',
        component: Doc,
        meta: {
          pageType: 'doc'
        }
      },
      {
        path: 'code',
        name: 'Code',
        component: Code,
        meta: {
          pageType: 'code'
        }
      },
      {
        path: 'toolsCenter',
        name: 'toolsCenter',
        component: ToolsCenter,
        meta: {
          pageType: 'toolsCenter'
        }
      }
    ]
  },
  {
    path: '/collection',
    name: 'collection',
    component: Collection
  },
  {
    path: '/feedback',
    name: 'FeedBack',
    component: FeedBack
  },
  {
    path: '/report',
    name: 'Report',
    component: Report
  },
  // 支付
  {
    path: '/pay',
    name: 'Pay',
    component: Pay
  },
  {
    path: '/pay/goods',
    name: 'PayGoods',
    component: PayGoods
  },
  {
    path: '/pay/order',
    name: 'PayOrder',
    component: PayOrder
  },
  {
    path: '/pay/order/feedback',
    name: 'PayOrderFeedback',
    component: PayOrderFeedback
  },
  {
    path: '/pay/question',
    name: 'PayQuestion',
    component: PayQuestion
  },
  {
    path: '/pay/policy/vipservice',
    name: 'PayVipServicePolicy',
    component: PayVipServicePolicy
  },
  {
    path: '/pay/policy/continue',
    name: 'PayContinuePolicy',
    component: PayContinuePolicy
  },
  {
    path: '/pay/invoice',
    name: 'PayInvoice',
    component: PayInvoice
  },
  {
    path: '/cloud/knowledge',
    name: 'CloudKnowledge',
    component: CloudKnowledge
  },
  {
    path: '/wx/code/page',
    name: 'WxCodePage',
    component: WxCodePage
  },
  // ! 针对异步路由刷新会跳转404，暂未找出原因，故先注释
  {
    // 用于针对同步路由的404，异步路由也有404，同步路由个异步路由合并的时候进行唯一处理
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]
// 异步路由
export const asyncRoutes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: () => ({
    top: 0
  }),
  routes: constantRoutes,
  sensitive: true,
  strict: true
})

const glmsName = ['Glms', 'alltoolsdetail', 'gdetail']
router.beforeEach((to, from, next) => {
  const phone = store.state.Home?.userInfo?.phone
  console.log('to: ', to, 'from: ', from)
  // if (to.name === 'alltoolsdetail' || to.name === 'Detail') {
  //   document.title = 'ChatGLM - 智谱清言'
  // } else
  // 切换路由时 清空当前智能体信息
  store.commit('Conversation/SET_CUR_ASSIST', {})
  if (to.name !== 'gdetail') {
    // 如果不是智能体页面 重置title
    document.title = '智谱清言'
  }
  if (!phone && to.path.startsWith('/main/') && to.path !== '/main/detail') {
    // 智能体分享页面
    if (to.meta?.isGlmsShare && to.query?.share_conversation_id) {
      console.log('智能体分享页面')
      return next()
    }
    return next()
  }

  let redirectedFrom = to?.redirectedFrom
  if (typeof redirectedFrom === 'object') {
    redirectedFrom = redirectedFrom.redirectedFrom || redirectedFrom.fullPath
  }
  if (redirectedFrom?.startsWith('/agentShare') && to.name !== 'gdetail') {
    const id = to.query?.id

    return next({
      path: `/main/gdetail/${id}`
    })
  }

  if (glmsName.indexOf(to.name) === -1) {
    store.commit('Glms/SET_ASSISTANT_ID', '')
    store.commit('Glms/SET_ASSISTANT_INFO', {})
  }
  // store.commit('Conversation/RESET_DATA_LIST')
  store.commit('Glms/SET_ASSISTANT_ID', '')
  store.commit('UploadFile/SET_FILELIST', [])

  next()
})

router.afterEach((to, from) => {
  // 判断是否是支付页面与图片编辑页面之间的跳转
  const isPayJump =
    (from.path === '/pay/goods' && from.query.from === 'imageEdit') ||
    (to.path === '/pay/goods' && to.query.from === 'imageEdit')
  if (isPayJump) {
    // 如果是从支付页面返回到图片编辑页面，则不清空数据
    return
  }
  // 如果是图片编辑页面的返回 则不清空数据
  if (to.fullPath === from.fullPath) {
    return
  }
  // 重置对话数据  这步放到beforeEach的话 会导致当前页面的欢迎页重新加载 使得欢迎页抖动
  store.commit('Conversation/RESET_DATA_LIST')
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
